import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const baoCaoMenu: NavMenu = {
  title: 'Báo cáo',
  items: [
    {
      title: 'Quỹ',
      icon: <AritoIcon icon={430} />,
      items: [
        {
          title: 'Sổ quỹ in từng ngày',
          href: '/bao-cao/quy/so-quy-in-tung-ngay'
        }
      ]
    },
    {
      title: 'Bán hàng',
      icon: <AritoIcon icon={207} />,
      items: [
        {
          title: 'Báo cáo doanh thu theo ngày*',
          icon: <AritoIcon icon={230} />,
          href: '/bao-cao/ban-hang/bao-cao-doanh-thu-theo-ngay'
        },
        {
          title: 'Báo cáo lãi gộp theo cửa hàng',
          icon: <AritoIcon icon={230} />,
          href: '/bao-cao/ban-hang/bao-cao-lai-gop-theo-cua-hang'
        },
        {
          title: 'Báo cáo lãi gộp theo mặt hàng',
          icon: <AritoIcon icon={230} />,
          href: '/bao-cao/ban-hang/bao-cao-lai-gop-theo-mat-hang'
        }
      ]
    }
  ]
};
